import { types } from "mobx-state-tree";
import { IErrors, IFileSizes, WarningLayers } from "../jsxProviders";
import { clearCache } from "../jsxProviders/helpers/tmpDir";
export type ProblemLayers = { errors: IErrors; name: string }[];
export const UIStore = types
  .model({
    drawerVisible: types.optional(types.boolean, false),
    addSceneModalVisible: types.optional(types.boolean, false),
    createProjectModalVisible: types.optional(types.boolean, false),
    deleteSceneModalVisible: types.optional(types.boolean, false),
    sceneHasDataModalVisible: types.optional(types.boolean, false),
    renderProcessVisible: types.optional(types.boolean, false),
    dontAskAgainOverrideSceneData: types.optional(types.boolean, false),
    alertModalVisible: types.optional(types.boolean, false),
    alertMessage: types.optional(types.string, ""),
    newerVersionModalType: types.maybeNull(types.string),
    newerVersionLink: types.optional(types.string, ""),
    newerVersionNumber: types.optional(types.string, ""),
    newerUiVersionNumber: types.optional(types.string, ""),
    problemLayersModalVisible: types.optional(types.boolean, false),
    sizeProblemDataModalVisible: types.optional(types.boolean, false),
    fileSizeErrorData: types.optional(types.frozen(), {}),
    warningData: types.optional(types.frozen(), []),
    warningModalVisible: types.optional(types.boolean, false),
    renderProgress: types.optional(types.number, 0),
    filterComposition: types.optional(types.boolean, false),
    continueRendering: types.optional(types.boolean, false),
  })
  .views(() => ({}))
  .actions((self) => {
    let problemLayers: ProblemLayers = [];
    return {
      getProblemLayers() {
        return problemLayers;
      },
      setDrawerVisible() {
        self.drawerVisible = true;
      },
      setDrawerHidden() {
        self.drawerVisible = false;
      },
      setCreateProjectModalVisible() {
        self.createProjectModalVisible = true;
      },
      setCreateProjectModalHidden() {
        self.createProjectModalVisible = false;
      },
      setSceneModalVisible() {
        self.addSceneModalVisible = true;
      },
      setSceneModalHidden() {
        self.addSceneModalVisible = false;
      },
      setDeleteSceneModalHidden() {
        self.deleteSceneModalVisible = false;
      },
      setDeleteSceneModalVisible() {
        self.deleteSceneModalVisible = true;
      },
      setSceneHasDataModalHidden() {
        self.sceneHasDataModalVisible = false;
      },
      setSceneHasDataModalVisible() {
        self.sceneHasDataModalVisible = true;
      },
      setFilterCompositions(flag: boolean) {
        self.filterComposition = flag;
      },
      setRenderProcessHidden() {
        self.renderProcessVisible = false;
      },
      setRenderProcessVisible() {
        self.renderProcessVisible = true;
      },
      setDontAskAgainOverrideSceneData(checked: boolean) {
        self.dontAskAgainOverrideSceneData = checked;
      },
      setAlertModalVisible() {
        self.alertModalVisible = true;
      },
      setAlertModalHidden() {
        self.alertModalVisible = false;
        self.alertMessage = "";
      },
      setAlertMessage(message: string) {
        self.alertMessage = message;
      },
      addToAlertMessage(message: string) {
        self.alertMessage += message;
      },
      setNewerVersionModalVisible(type: "ui" | "main") {
        self.newerVersionModalType = type;
        if (type === "ui") {
          clearCache();
        }
      },
      setNewerVersionModalHidden() {
        self.newerVersionModalType = null;
        self.newerVersionLink = "";
      },
      setNewerVersion(url: string, version: string, uiVersion: string) {
        self.newerVersionLink = url;
        self.newerVersionNumber = version;
        self.newerUiVersionNumber = uiVersion;
      },
      setProblemLayersData(data: Partial<IErrors>, name: string) {
        const errors: IErrors = {
          Wav: [],
          AudOffset: [],
          AudLock: [],
          VidTrack: [],
          CompCollapse: [],
          TextDeformed: [],
          UnsupportedFormat: [],
          LayerLocked: [],
          NameError: [],
          FontError: [],
          UnknownError: [],
          ...data,
        };
        problemLayers.push({ errors, name });
      },
      resetProblemLayersData() {
        problemLayers = [];
      },
      setProblemLayersModalHidden() {
        self.problemLayersModalVisible = false;
      },
      setProblemLayersModalVisible() {
        self.problemLayersModalVisible = true;
      },
      setRenderProgress(progress: number) {
        self.renderProgress = progress;
      },
      setSizeProblemData(data: {
        totalFilesSize: number;
        fileSizes: IFileSizes[];
      }) {
        self.fileSizeErrorData = data;
      },
      setWarningData(warningLayers: WarningLayers ) {
        self.warningData = warningLayers;
      },
      setSizeProblemDataModalVisible() {
        self.sizeProblemDataModalVisible = true;
      },
      setSizeProblemDataModalHidden() {
        self.sizeProblemDataModalVisible = false;
      },
      setWarningModalHidden() {
        self.warningModalVisible = false;
      },
      setWarningModalVisible() {
        self.warningModalVisible = true;
      },
    };
  });
